import { render, staticRenderFns } from "./StatusBar.vue?vue&type=template&id=3da2e0c4&scoped=true&"
import script from "./StatusBar.vue?vue&type=script&lang=js&"
export * from "./StatusBar.vue?vue&type=script&lang=js&"
import style0 from "./StatusBar.vue?vue&type=style&index=0&id=3da2e0c4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3da2e0c4",
  null
  
)

export default component.exports